class SiblingsSelector extends HTMLElement {
    constructor() {
        super();
        // We're going to use the predictive search Ajax API
        this.searchQueryUrl = this.getAttribute('data-siblings-search-url');
        this.templateElement = this.querySelector('[data-siblings-item-template]');
        this.siblingsList = this.querySelector('[data-siblings-list]');

        if(!this.searchQueryUrl){
            console.warn('Could not find data-siblings-search-url attribute, exiting!');
            return
        }
        if(!this.templateElement){
            console.warn('Could not find template element for siblings, exiting!');
            return
        }
        if(!this.siblingsList){
            console.warn('Could not find list element for siblings, exiting!');
            return
        }

        this.init();
    }

    async init () {
        this.siblings = await this.fetchSiblings();
        if(this.siblings) {
            this.renderSiblings();
        }
    }

    async fetchSiblings(){
        if(this.searchQueryUrl) {
            return await fetch(this.searchQueryUrl)
                .then((response) => response.json())
                .then((siblings) => {
                     if(siblings.resources && siblings.resources.results && siblings.resources.results.products) {
                        return siblings.resources.results.products;
                     }
                    }
                );
        }
    }

    async renderSiblings(){
        this.siblings.forEach((sibling) => {
            const siblingID = sibling.id;
            const siblingInDOM = this.querySelector(`[data-siblings-product-id="${siblingID}"]`);

            if(siblingInDOM) {
                console.warn(`Sibling ID: ${siblingID} is already in DOM, skipping update...`);
                return;
            }

            const siblingHTML = this.templateElement.content.cloneNode(true);

            const siblingTitle = `${sibling.vendor} - ${sibling.title}`;
            siblingHTML.querySelector('[data-siblings-product]').setAttribute('href', sibling.url);
            siblingHTML.querySelector('[data-siblings-product]').setAttribute('data-siblings-product-id', siblingID);
            siblingHTML.querySelector('[data-siblings-product]').setAttribute('title', siblingTitle);
            siblingHTML.querySelector('[data-siblings-product] img').setAttribute('src', sibling.featured_image.url);

            if(this.siblingsList) {
                this.siblingsList.appendChild(siblingHTML);
            }
        });
    }
}

customElements.define('siblings-selector', SiblingsSelector);
